// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__2Te89","label":"Checkbox_label__3mzoy","checkmark":"Checkbox_checkmark__2Eec2"};